var E = /* @__PURE__ */ ((T) => (T.DELETE = "DELETE", T.PATCH = "PATCH", T.POST = "POST", T.PUT = "PUT", T.GET = "GET", T))(E || {});
export {
  E as HttpMethod
};
